import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { api } from "@/lib/api";
import { Header } from "@/components/landing/Header";
import { ContactSection } from "@/components/landing/ContactSection";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { RegisterForm } from "@/components/portal/RegisterForm";
import { LoginForm } from "@/components/portal/LoginForm";
import { ForgotForm } from "@/components/portal/ForgotForm";
import { useJamaah } from "@/context/JamaahContext";

export default function Bergabung() {
  const { jamaah } = useJamaah();
  const [profile, setProfile] = useState(null);
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get("tab") === "daftar" ? "daftar" : "masuk");
  const [forgot, setForgot] = useState(false);

  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  if (jamaah) return <Navigate to="/portal" replace />;

  return (
    <div className="min-h-screen bg-background" data-testid="bergabung-page">
      <Header profile={profile} />
      <section className="emerald-bg pattern-overlay text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#80b996]">Portal Jamaah</p>
          <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">Bergabung dengan Al-Iman Digital</h1>
          <p className="mt-3 text-emerald-100/85 max-w-2xl">Daftar sebagai jamaah untuk melihat riwayat donasi, berlangganan pengingat kegiatan via WhatsApp, dan menyampaikan saran kepada pengurus.</p>
        </div>
      </section>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid lg:grid-cols-12 gap-10">
        <aside className="lg:col-span-5 space-y-5">
          {[
            ["Donasi Saya", "Riwayat infaq, sedekah, dan zakat yang Anda salurkan, lengkap dengan statusnya."],
            ["Pengingat Kegiatan", "Pilih kategori kegiatan (Kajian Rutin, Shalat Jumat, dll). Kami ingatkan via WhatsApp saat jadwal dikonfirmasi."],
            ["Saran & Aspirasi", "Sampaikan masukan langsung ke pengurus DKM melalui portal."],
          ].map(([t, d]) => (
            <div key={t} className="rounded-2xl border border-emerald-900/10 bg-white p-5">
              <p className="font-semibold text-emerald-950">{t}</p>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">{d}</p>
            </div>
          ))}
        </aside>
        <div className="lg:col-span-7">
          <div className="rounded-3xl border border-emerald-900/10 bg-white p-6 sm:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-11 w-11 rounded-2xl emerald-bg flex items-center justify-center text-[#d4af37]"><UserPlus size={22} /></div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700">Akun Jamaah</p>
                <h2 className="text-xl font-bold text-emerald-950">{forgot ? "Reset Kata Sandi" : tab === "daftar" ? "Daftar Jamaah Baru" : "Masuk Portal Jamaah"}</h2>
              </div>
            </div>
            {forgot ? (
              <ForgotForm onBack={() => setForgot(false)} />
            ) : (
            <Tabs value={tab} onValueChange={setTab}>
              <TabsList className="grid grid-cols-2 w-full mb-6">
                <TabsTrigger value="masuk" data-testid="bergabung-tab-masuk">Masuk</TabsTrigger>
                <TabsTrigger value="daftar" data-testid="bergabung-tab-daftar">Daftar</TabsTrigger>
              </TabsList>
              <TabsContent value="masuk"><LoginForm onRegister={() => setTab("daftar")} onForgot={() => setForgot(true)} /></TabsContent>
              <TabsContent value="daftar"><RegisterForm /></TabsContent>
            </Tabs>
            )}
          </div>
        </div>
      </main>
      <ContactSection profile={profile} />
    </div>
  );
}
